import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
    members: Yup.array().of(
        Yup.object().shape({
            memberId: Yup.string().required('Member is required'),
            role: Yup.string().required('Role is required'),
            billableType: Yup.string().required('Billable type is required'),
            rateType: Yup.string().when('billableType', {
                is: 'billable',
                then: schema => schema.required('Rate type is required'),
                otherwise: schema => schema,
            }),
            employmentType: Yup.string().when('billableType', {
                is: 'billable',
                then: schema => schema.required('Employment type is required'),
                otherwise: schema => schema,
            }),
            rate: Yup.string().when('billableType', {
                is: 'billable',
                then: schema => schema.required('Rate is required'),
                otherwise: schema => schema,
            }),
        })
    ),
    effectiveFrom: Yup.date().nullable(),
});
